import React, { useCallback } from 'react';
import { prop, pick } from 'ramda';
import Tabs from 'js/components/common/Tabs';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'js/hooks/navigate';
import { useTranslations } from 'js/hooks/i18n';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import style from './AboveMainContent.scss';

export const AboveMainContent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isMobile, isTablet } = useDeviceSelector(pick(['isMobile', 'isTablet']));
    const t = useTranslations('playtech.mobile.system.tabs.');
    const classNames = { active: style.activeTab, tab: style.tab };
    const { DTAG_PROMOTIONS_PAGE, DTAG_BONUS_HISTORY_PAGE } = useAppSelector(prop('dynamicTags'));

    const mobileOrTablet = isMobile || isTablet;
    const isTabsShown = mobileOrTablet && [DTAG_PROMOTIONS_PAGE, DTAG_BONUS_HISTORY_PAGE].includes(location.pathname);

    const onClick = useCallback((name) => {
        navigate(name);
    }, [navigate]);

    const tabs = [
        { name: DTAG_PROMOTIONS_PAGE, title: t('promotions'), onClick, classNames },
        { name: DTAG_BONUS_HISTORY_PAGE, title: t('myBonuses'), onClick, classNames }
    ];

    return (
        <>
            {isTabsShown
                && <Tabs activeTab={location.pathname} tabs={tabs} className={style.tabs} />}
        </>
    );
};
